import { Offer as GraphQlOffer } from "@acto/gql/graphql";

export type OfferSummaryInput = Pick<GraphQlOffer, "validFrom" | "value">;

export default class OfferSummary {
  constructor(
    public readonly validFrom?: string,
    public readonly value?: number,
  ) {}

  static fromGraphql(data?: OfferSummaryInput | null): OfferSummary | undefined {
    if (!data) return undefined;
    return new OfferSummary(data.validFrom ?? undefined, data.value ?? undefined);
  }
}
